import { render, staticRenderFns } from "./ProjetoFormulario.vue?vue&type=template&id=2ced0aa8&"
import script from "./ProjetoFormulario.vue?vue&type=script&lang=js&"
export * from "./ProjetoFormulario.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoFormulario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports